import {Box, Grid} from '@mui/material';
import {AppTabs, TabsType} from 'components/tabs';
import {useGetAllBoardViews, useGetAllItemStatusesByBoardId} from 'hooks';
import {BoardView, BoardViewTypeEnum} from 'models/board/boardView.model';
import React, {useEffect, useMemo, useState} from 'react';
import {RenderBoardViews} from './RenderBoardViews';
import {useParams} from 'react-router-dom';
import {useItemDataState} from 'providers';
import {useGetAllBoardForms} from 'hooks/board';
import {useDispatch} from 'react-redux';
import {setDefaultBoardForm} from 'store/boards/boardSlice';

export const AppBoardViews: React.FC = () => {
    const [selectedBoardView, setSelectBoardView] = useState<BoardViewTypeEnum>(BoardViewTypeEnum.Kanban);
    const {boardId} = useParams();
    const {clearBoardItemData} = useItemDataState();
    const dispatch = useDispatch();
    const {getAllBoardForms, getAllBoardFormsLoading, getAllBoardFormsResponse} = useGetAllBoardForms();

    const {getAllItemStatuses, getAllStatusesLoading, getAllStatusessResponse} = useGetAllItemStatusesByBoardId();
    const {getAllBoardViewsByBoardId, getAllBoardViewsByBoardIdLoading, getAllBoardViewsByBoardResponse} =
        useGetAllBoardViews();

    useEffect(() => {
        if (boardId) {
            getAllBoardViewsByBoardId({variables: {boardSlug: boardId}});
            getAllItemStatuses({variables: {boardSlug: boardId}});
            getAllBoardForms({variables: {where: {board: {slug: {eq: boardId}}}}});
        }
    }, [boardId]);
    useEffect(() => {
        if (!getAllBoardFormsLoading && getAllBoardFormsResponse) {
            const defaultForm = getAllBoardFormsResponse.find(x => x.isDefault);
            if (defaultForm) {
                dispatch(setDefaultBoardForm(defaultForm));
            }
            // Handle the response from getAllBoardForms
        }
    }, [getAllBoardFormsLoading, getAllBoardFormsResponse]);

    useEffect(() => {
        if (!getAllBoardViewsByBoardIdLoading && getAllBoardViewsByBoardResponse) {
            if (getAllBoardViewsByBoardResponse.length > 0) {
                setSelectBoardView(getAllBoardViewsByBoardResponse[0].boardViewType);
            }
        }
    }, [getAllBoardViewsByBoardResponse, getAllBoardViewsByBoardIdLoading]);

    const selectedBoardViewObject = useMemo(() => {
        if (getAllBoardViewsByBoardResponse && selectedBoardView) {
            return getAllBoardViewsByBoardResponse?.find(x => x.boardViewType === selectedBoardView);
        }
    }, [selectedBoardView, getAllBoardViewsByBoardResponse]);
    const tabs = useMemo((): TabsType<BoardViewTypeEnum>[] => {
        if (getAllBoardViewsByBoardResponse) {
            return [
                ...getAllBoardViewsByBoardResponse.map((boardView: BoardView) => {
                    return {
                        key: boardView.boardViewType,
                        title: boardView.title,
                    };
                }),
            ];
        }
        return [];
    }, [getAllBoardViewsByBoardResponse]);
    const handleAfterChange = (value: BoardViewTypeEnum) => {
        clearBoardItemData();
        setSelectBoardView(value as BoardViewTypeEnum);
    };
    return (
        <>
            <Box>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <AppTabs<BoardViewTypeEnum>
                            tabs={tabs}
                            loading={getAllBoardViewsByBoardIdLoading}
                            selectedTabValue={selectedBoardView}
                            scrollableEvent={true}
                            variant="scrollable"
                            handleAfterChange={handleAfterChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {selectedBoardViewObject && (
                            <RenderBoardViews
                                selectedBoardView={selectedBoardViewObject}
                                getAllStatusesLoading={getAllStatusesLoading}
                                itemStatuses={getAllStatusessResponse ?? []}
                            />
                        )}
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default AppBoardViews;
